import { useTranslation } from 'react-i18next';

import { Typography } from '@packages/fenrir/components';

export const AccountInformationStep = () => {
  const { t } = useTranslation('telemetryCloudScanners');
  return (
    <div>
      <Typography variant="h5">
        {t('stepLabels.provideAccountInformation')}
      </Typography>
    </div>
  );
};
